import React from "react";
import PropTypes from "prop-types";
import HighchartsReact from "highcharts-react-official";

const Highcharts = window.Highcharts;

function InventoryPriceOverview({ data }) {
  const chartData = data.map((data) => [data.price, data.list]);

  const chartOptions = {
    chart: {
      type: "pie",
    },
    title: {
      text: "Vehicles Clicks by Price",
      style: {
        fontWeight: "bold",
        fontSize: "14",
      },
    },
    tooltip: {
      pointFormat: "{series.name}: <b>{point.percentage:.0f}%</b>",
      percentageDecimals: 1,
    },
    exporting: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        colors: ["#74C372", "#428BCA", "#FFBF00", "#573B7A", "#E35D6A"],
        depth: 30,
        dataLabels: {
          enabled: false,
          formatter: function () {
            return (
              "<b>" +
              this.point.name +
              "</b>: " +
              Highcharts.numberFormat(this.percentage, 0) +
              " %"
            );
          },
        },
        showInLegend: true,
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        type: "pie",
        name: "Percentage",
        data: chartData,
      },
    ],
  };

  return (
    <div className="col-md-4 col-xs-12">
      <div style={{ height: "400px" }}>
        <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      </div>
    </div>
  );
}

InventoryPriceOverview.propTypes = {
  data: PropTypes.array.isRequired,
};

export default InventoryPriceOverview;
